export default {
  getMessages: (state, getters) => {
    const me = getters.getMyInfo
    if (state.messages && me) {
      if (me.hasRoles) {
        // Nutritionist & Parents/Coachs should see all messages
        return state.messages
      } else {
        return state.messages.filter(m => {
          if (m.tempMessage) return true
          if (!m.client || !m.client.nutritionist || !m.nutritionist) return false
          return m.client.nutritionist._id === m.nutritionist._id
        })
      }
    }
  },
  getMessageThread: (state, getters) => {
    if (state.messageThread) {
      return state.messageThread
    } else {
      return null
    }
  },
  getMessageParticipants: (state, getters) => {
    if (state.participants) {
      return state.participants
    } else {
      return null
    }
  },
  getParticipantConsent: (state, getters) => {
    if (state.participantConsent) {
      return state.participantConsent
    } else {
      return null
    }
  },
  getMessageListeners: (state, getters) => {
    if (state.messageListeners) {
      return state.messageListeners
    } else {
      return []
    }
  },
  newMessageSchema: (state, getters) => {
    if (state.messageSchema) {
      return state.newMessageSchema
    } else {
      return null
    }
  },
  hasUnread: (state, getters) => {
    if (state.hasUnread) {
      return state.hasUnread
    } else {
      return null
    }
  },
  activeThread: (state, getters) => {
    if (state.activeThread) {
      return state.activeThread
    } else {
      return null
    }
  },
  newMessage: (state, getters) => {
    if (state.newMessage) {
      return state.newMessage
    } else {
      return null
    }
  },
  newSignup: (state, getters) => {
    if (state.newSignup) {
      return state.newSignup
    } else {
      return null
    }
  },
  canSend: (state, getters) => {
    return state.canSend
  },
  skipMessage: (state, getters) => {
    return state.skip
  }
}



// WEBPACK FOOTER //
// ./src/app/store/messaging/getters.js